import { render, staticRenderFns } from "./DocListCard.vue?vue&type=template&id=8794a25e&"
import script from "./DocListCard.vue?vue&type=script&lang=js&"
export * from "./DocListCard.vue?vue&type=script&lang=js&"
import style0 from "./DocListCard.vue?vue&type=style&index=0&id=8794a25e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports